import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsXrange from 'highcharts/modules/xrange';
import HighchartsExporting from 'highcharts/modules/exporting';
import HighchartsAccessibility from 'highcharts/modules/accessibility';
import { fetchTimelineData } from '../../../../api/sentinelAPI';
import { Box, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';

// Initialize the additional Highcharts modules
HighchartsXrange(Highcharts);
HighchartsExporting(Highcharts);
HighchartsAccessibility(Highcharts);

const Timeline = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const date = useSelector((state) => state.customization.currentDate);
  const zone = useSelector((state) => state.customization.selectedZone);

  const selectedTime = useSelector((state) => state.customization.selectedTime);
  const startTime = new Date(selectedTime.start_time);
  const endTime = new Date(selectedTime.end_time);

  const formattedStartTimeIST = startTime.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }).split(',')[1];
  const formattedEndTimeIST = endTime.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }).split(',')[1];

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    async function getData() {
      setLoading(true);
      const body = {
        start_time: formattedStartTimeIST,
        end_time: formattedEndTimeIST,
        start_date: date,
        zone_name: zone,
        storeId: '65c5e26a0b5be5dc7af327dc'
      };
      try {
        let fetchedData = await fetchTimelineData(body, { signal });
        fetchedData = fetchedData.engagement;
        if (!signal.aborted && fetchedData && fetchedData.length > 0) {
          const transformedData = fetchedData.map((item) => {
            if (item) {
              const x = new Date(item.starting_time).getTime();
              const x2 = new Date(item.ending_time).getTime();
              const y2 = item._id;
              return {
                x,
                x2,
                y: 1,
                y2
              };
            } else {
              console.error('Invalid item structure:', item);
              return null;
            }
          });
          setData(transformedData.filter((item) => item !== null));
        } else {
          setData(null);
        }
      } catch (error) {
        if (!signal.aborted) {
          console.log(error);
        }
      } finally {
        if (!signal.aborted) {
          setLoading(false);
        }
      }
    }

    getData();

    return () => {
      abortController.abort();
    };
  }, [date, zone, formattedStartTimeIST, formattedEndTimeIST]);

  useEffect(() => {
    if (!data) return;

    Highcharts.chart('container', {
      colors: ['#774D97'],
      chart: {
        type: 'xrange',
        scrollablePlotArea: {
          minHeight: data.length * 10,
          opacity: 1,
          scrollPositionY: 0
        }
      },
      navigation: {
        buttonOptions: {
          enabled: false
        }
      },
      title: {
        text: ''
      },
      accessibility: {
        point: {
          descriptionFormat: '{add index 1}. {yCategory}, {x:%A %e %B %Y} to {x2:%A %e %B %Y}.'
        }
      },
      xAxis: {
        type: 'datetime',
        gridLineWidth: 1,
        opacity: 1,
        scrollbar: {
          enabled: true
        }
      },
      yAxis: {
        type: 'category',
        visible: false,
        scrollbar: {
          enabled: true
        },
        tickLength: 0,
        categories: data.map((item) => item.y2),
        reversed: true
      },
      legend: {
        enabled: false,
        align: 'center',
        verticalAlign: 'top',
        itemStyle: {
          color: '#774D97'
        }
      },

      series: [
        {
          name: 'Customer',
          pointPadding: 0,
          groupPadding: 0,
          pointWidth: 7,
          data: data.map((item, index) => ({
            x: item.x,
            x2: item.x2,
            y: index
          })),
          legendColor: '#774D97',
          showInLegend: true
        }
      ]
    });
  }, [data]);

  return (
    <Box>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="300px">
          <CircularProgress />
        </Box>
      ) : data && data.length > 0 ? (
        <div className="highcharts-figure">
          <div id="container"></div>
          <div id="white-box"></div>
        </div>
      ) : (
        <div className="w-full h-[400px] flex justify-center place-items-center text-xl">No data</div>
      )}
      <div className="bg-white h-4 w-20 absolute right-1.5 bottom-0 z-20 "> </div>
    </Box>
  );
};

export default Timeline;
